import { gql } from '__generated__';

export default gql(`
  query GetTicketsAndProductsForParticipantFields($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        tickets {
          id
          title
          promotions {
            id
            title
          }
        }
        products {
          id
          title
          promotions {
            id
            title
          }
        }
        invitations {
          id
          title: prefix
        }
      }
    }
  }
`);
